module.exports = "/images/ocultar.svg?384d555d152dd452a923258ddeefeff7";